import { render, staticRenderFns } from "./right1.vue?vue&type=template&id=0ac0c41d&scoped=true&"
import script from "./right1.vue?vue&type=script&lang=js&"
export * from "./right1.vue?vue&type=script&lang=js&"
import style0 from "./right1.vue?vue&type=style&index=0&id=0ac0c41d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac0c41d",
  null
  
)

export default component.exports